<template>
  <div 
    v-if="isVisible"
    class="absolute top-full left-0 right-0 z-50 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg"
  >
    <div class="p-4">
      <!-- Header -->
      <div class="flex items-center justify-between mb-4">
        <h3 class="text-lg font-medium text-gray-900">{{ title }}</h3>
        <button @click="$emit('close')" class="text-gray-400 hover:text-gray-600 transition-colors">
          <Close class="w-5 h-5" />
        </button>
      </div>

      <!-- Date Picker -->
      <v-date-picker 
        :model-value="modelValue" 
        @update:model-value="(value: Date | null) => emit('update:modelValue', value)"
        mode="date" 
        transparent 
        borderless 
        expanded 
        :min-date="minDate" 
        :max-date="maxDate"
        :disabled-dates="disabledDates"
        @dayclick="handleDayClick"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import Close from 'vue-material-design-icons/Close.vue'

interface Props {
  isVisible: boolean
  title: string
  modelValue: Date | null
  minDate: Date
  maxDate: Date
  disabledDates: Date[]
}

defineProps<Props>()

const emit = defineEmits<{
  'update:modelValue': [Date | null]
  close: []
}>()

// @ts-ignore
const handleDayClick = (day: any, event: any) => {
  event.target.blur()
}
</script> 